import type { ReactNode } from "react";
import { Button, ButtonText } from "../../../../ui/button";

type Props = {
  selected: boolean;
  disabled?: boolean;
  onPress: () => void;
  role: "radio" | "checkbox";
  children: ReactNode;
};

/**
 * One choice, as a pill: brand-filled when picked, muted outline when not.
 *
 * `min-h-11` is the 44px touch target — `size="xs"` alone is 32px, which is a miss
 * waiting to happen on a form people fill in with a trackpad or a thumb. `h-auto` and
 * `max-w-full` let a long label wrap inside a narrow card instead of running past it.
 */
const Chip = ({
  selected,
  disabled = false,
  onPress,
  role,
  children,
}: Props) => (
  <Button
    action={selected ? "brand" : "muted"}
    variant={selected ? "solid" : "outline"}
    size="xs"
    rounded="full"
    className="h-auto min-h-11 max-w-full py-2"
    isDisabled={disabled}
    onPress={onPress}
    role={role}
    aria-checked={selected}
  >
    <ButtonText className="shrink text-center">{children}</ButtonText>
  </Button>
);

export default Chip;
